import React from 'react';
import cx from 'classnames';
import Spinner from 'app/shared/spinners/spinner-15/spinner-15';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { ReactComponent as Logo } from 'assets/icons/logo-sm.svg';
import styles from '../create.module.css';

/**
 * Shared visual chrome for every step of the agency creation flow: logo header,
 * optional step indicator, title/subtitle, the step body, and the Back/Primary
 * action row. An optional `modal` is rendered after the card.
 */
export const FlowShell = ({
  steps = null,
  current = 1,
  title,
  subtitle,
  onBack,
  backDisabled = false,
  primaryLabel = 'Continue →',
  onPrimary,
  primaryDisabled = false,
  busy = false,
  modal = null,
  children
}) => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <Logo />
      <span className={styles.siteName} aria-label="Go-Mailer">
        Go-Mailer<span className={styles.stub}>.</span>
      </span>
    </div>

    <div className={styles.formWrapper}>
      {steps && (
        <div className={styles.steps}>
          {steps.map((label, i) => (
            <div key={label} className={styles.stepSegmentWrap}>
              <div
                className={cx(styles.stepSegment, current >= i + 1 && styles.stepSegmentFilled)}
              />
              <span
                className={cx(
                  styles.stepSegmentLabel,
                  current === i + 1 && styles.stepSegmentLabelActive
                )}
              >
                {label}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className={styles.formTitle}>{title}</div>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

      {children}

      <div className={styles.actionRow}>
        <GridRow num_of_columns={2}>
          <GridColumn>
            <button className={styles.btnSecondary} onClick={onBack} disabled={backDisabled}>
              ← Back
            </button>
          </GridColumn>
          <GridColumn>
            <button
              className={styles.btnPrimary}
              onClick={onPrimary}
              disabled={busy || primaryDisabled}
            >
              {busy ? <Spinner /> : primaryLabel}
            </button>
          </GridColumn>
        </GridRow>
      </div>
    </div>

    {modal}
  </div>
);
